import {atom} from 'recoil';
import {currentUserType} from '../../types/currentUser';

export const currentUser = atom<currentUserType>({
  key: 'currentUser',
  default: undefined,
});
